<template>
  <div class="shadow-xs rounded">
    <div class="shadow-lg rounded bg-white flex flex-col">
      <div class="inline-flex px-4 h-12 items-center">
        <span class="inline-block truncate text-sm">
          {{ name }}
        </span>
      </div>
      <a
        :href="url"
        target="_blank"
        class="relative bg-gray-100"
        style="padding-bottom: 66.666667%"
      >
        <img v-if="url" :src="url" class="absolute w-full h-full object-cover" />
        <div v-else class="absolute w-full h-full inline-flex items-center justify-center">
          <div class="flex flex-col items-center space-y-4">
            <svg viewBox="0 0 24 24" fill="currentColor" class="h-12 w-12 text-gray-600">
              <path
                d="M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1
                1 0 0 1 1-1h6zm11-3v8h-2V6.413l-7.793
                7.794-1.414-1.414L17.585 5H13V3h8z"
              />
            </svg>
            <p class="text-gray-900">No preview available</p>
          </div>
        </div>
      </a>
      <div v-if="editable" class="px-4 py-3">
        <div v-if="displayConfirmationMessage" class="flex flex-col space-y-2">
          <BaseButton danger small :disabled="pending" @click="deleteMedium"> Confirm </BaseButton>
          <BaseButton ghost small :disabled="pending" @click="displayConfirmationMessage = false">
            Cancel
          </BaseButton>
        </div>
        <div v-else class="flex flex-col space-y-2">
          <BaseButton ghost small @click="confirmDelete"> Delete </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinkAttachment',
  props: {
    id: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: null,
    },
    mimeType: {
      type: String,
      default: null,
    },
    taskId: {
      type: String,
      required: true,
    },
    editable: Boolean,
  },
  data() {
    return {
      displayConfirmationMessage: false,
      pending: false,
    };
  },
  methods: {
    confirmDelete() {
      this.displayConfirmationMessage = true;
      setTimeout(() => {
        if (this.pending) {
          return;
        }
        this.displayConfirmationMessage = false;
      }, 3000);
    },
    async deleteMedium() {
      try {
        this.pending = true;
        await this.$store.dispatch({
          type: 'ui/taskMedia/destroy',
          taskId: this.taskId,
          mediumId: this.id,
        });
      } catch (error) {
        //
      } finally {
        this.pending = false;
      }
    },
  },
};
</script>
